import { useEventCallback } from '@shared/utils/hooks/useEventCallback';
import { useState, useCallback } from 'react';

interface SwipeConfig {
  minSwipeDistance?: number;
}

interface SwipeHandlers {
  onTouchStart: (e: React.TouchEvent) => void;
  onTouchMove: (e: React.TouchEvent) => void;
  onTouchEnd: () => void;
}

export const useSwipeLeftRight = (config: SwipeConfig = {}, onSwipeLeft: () => void, onSwipeRight: () => void): SwipeHandlers => {
  const { minSwipeDistance = 50 } = config;
  const [touchStart, setTouchStart] = useState<number | null>(null);
  const [touchEnd, setTouchEnd] = useState<number | null>(null);

  const onTouchStart = useEventCallback((e: React.TouchEvent) => {
    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientX);
  });

  const onTouchMove = useEventCallback((e: React.TouchEvent) => {
    setTouchEnd(e.targetTouches[0].clientX);
  });

  const onTouchEnd = useCallback(() => {
    if (!touchStart || !touchEnd) return;

    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;

    if (isLeftSwipe) {
      onSwipeLeft();
    } else if (isRightSwipe) {
      onSwipeRight();
    }
  }, [touchStart, touchEnd, minSwipeDistance, onSwipeLeft, onSwipeRight]);

  return {
    onTouchStart,
    onTouchMove,
    onTouchEnd,
  };
};
